import { defineNuxtPlugin } from '#app'
import { setCustomIconLoader } from '@iconify/vue'
import { getIconData } from '@iconify/utils'
import type { IconifyJSON } from '@iconify/types'

// Resuelve los iconos que no quedaron en el bundle de cliente de @nuxt/icon
// (nombres dinamicos, p. ej. iconos de menu configurados en NexusCore) desde
// las colecciones @iconify-json/* instaladas, sin salir a api.iconify.design.
// Cada coleccion es un chunk aparte que se descarga, del mismo origen, solo la
// primera vez que se pide un icono suyo que no estaba en el bundle.

const collections: Record<string, () => Promise<IconifyJSON>> = {
  lucide: () => import('@iconify-json/lucide/icons.json').then(m => m.default as IconifyJSON),
  heroicons: () => import('@iconify-json/heroicons/icons.json').then(m => m.default as IconifyJSON),
  mingcute: () => import('@iconify-json/mingcute/icons.json').then(m => m.default as IconifyJSON),
}

const loaded = new Map<string, Promise<IconifyJSON>>()

export default defineNuxtPlugin(() => {
  for (const [prefix, load] of Object.entries(collections)) {
    setCustomIconLoader(async (name) => {
      if (!loaded.has(prefix)) {
        // Si el chunk falla (p. ej. red caida), se descarta para reintentar en el proximo icono.
        loaded.set(prefix, load().catch((error) => {
          loaded.delete(prefix)
          throw error
        }))
      }
      return getIconData(await loaded.get(prefix)!, name)
    }, prefix)
  }
})
